import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Button, Col, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import EInput, { EButton } from 'src/Components/EInput';
import { MessageStore } from 'src/Stores/Messages/Messages';
import { UserStore } from 'src/Stores/User/UserStore';
import DeepCopy from 'src/UtilityFunctions/DeepCopy';
import { IWarehouse } from '../../../../Interfaces/AdminInterface';
import DataService from '../../../../Services/Data';
import DataTable from '../../../DataTable';



interface IList {
    headers: any[];
    rows: any[];
}

@inject('stores')
@observer
class AdminWarehouses extends React.Component {
    public props: any;
    public adminStore: any;
    public warehousesDisposer: any; 
    public warehouses: IWarehouse[] = [];
    public warehouseList: IList;
    public dataService: any = new DataService();
    private UserStore: UserStore;
    private MessageStore: MessageStore;

    private tableHeaders: any[] = [
        { content: 'Name', 'class': 'align-left' },
        { content: 'Phone', 'class': 'align-left' },
        { content: 'Addr1', 'class': 'align-left' },
        { content: 'Addr2', 'class': 'align-left' },
        { content: 'City', 'class': 'align-left' },
        { content: 'State', 'class': 'align-left' },
        { content: 'Zip', 'class': 'align-left' },
    ];


    public state = {
        warehouse: new IWarehouse(),
        warehouseModalOpen: false,
        warehouses: this.warehouses,
    };

    constructor(props: any) {
        super(props);
        this.UserStore = props.stores.UserStore;
        this.adminStore = props.stores.AdminStore;
        this.MessageStore = props.stores.MessageStore;
    }

    public componentDidMount() {

        this.createDisposers();

        this.adminStore.getWarehouses();
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    public createDisposers() {
        this.warehousesDisposer = intercept(this.adminStore, 'warehouses', (change: any) => {
            let data = change.newValue;

            data = this.dataService.sort(data, { name: 'asc' });

            this.setState({
                warehouses: data
            });

            this.formatDataTable();

            return change;
        });
    }

    public clearDisposers() {
        this.warehousesDisposer();
    }

    public handleChange = (event: any) => {
        const warehouse = this.state.warehouse;

        warehouse[event.target.name] = event.target.value;

        this.setState({
            warehouse
        });
    }

    public toggleWarehouseModal = () => {
        this.setState({
            warehouse: new IWarehouse(),
            warehouseModalOpen: !this.state.warehouseModalOpen,
        });
    }

    public onEdit = (index: number) => {
        this.setState({
            warehouse: DeepCopy(this.state.warehouses[index]),
            warehouseModalOpen: true,
        });
    }

    public addAnother = () => {
        this.handleSaveWarehouse();
        this.setState({
            warehouse: new IWarehouse(),
        });
    }

    public handleSave = () => {
        this.handleSaveWarehouse();
        this.setState({
            warehouse: new IWarehouse(),
            warehouseModalOpen: false,
        });
    }

    public handleSaveWarehouse = () => {
        this.adminStore.saveWarehouse(this.state.warehouse)
            .then(
                (data: any) => {
                    if (data) {
                        this.MessageStore.addMessage(
                            'Changes have been saved',
                            'success'
                        );
                        this.adminStore.getWarehouses();
                    }
                },
                (error: any) => {
                    this.MessageStore.addMessage(
                        error.toString(),
                        'danger'
                    );
                }
            );
    }

    public removeWarehouse = (index: number) => {
        const warehouse = this.state.warehouses[index];
        this.adminStore.deleteWarehouse(warehouse)
            .then(
                (data: any) => {
                    if (data) {
                        this.MessageStore.addMessage(
                            'Warehouse Successfully Deleted',
                            'success'
                        );
                        this.adminStore.getWarehouses();
                    }
                }
            );
    }

    public formatDataTable() {
        const rows = this.state.warehouses.map((warehouse: IWarehouse, index: number) => {
            return [
                {
                    'class': 'align-left',
                    content : warehouse.name,
                },
                {
                    'class': 'align-left',
                    content: warehouse.phone
                },
                {
                    'class': 'align-left',
                    content: warehouse.addr1
                },
                {
                    'class': 'align-left',
                    content: warehouse.addr2
                },
                {
                    'class': 'align-left',
                    content: warehouse.city
                },
                {
                    'class': 'align-left',
                    content: warehouse.state
                },
                {
                    'class': 'align-left',
                    content: warehouse.zip
                }
            ];
        });

        return {
                headers: this.tableHeaders,
                rows
            };
    }

    public render() {
        return(
            <div>
                <Row className="header">
                    <Col md="6">
                        <h1 className="float-left">Warehouses</h1>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12">
                        <DataTable
                            list={this.formatDataTable()}
                            onNew={this.UserStore.hasPermission('Permissions.Admin.Warehouses.Create') ? {
                                callback: this.toggleWarehouseModal,
                                text: 'Add New Warehouse'
                            } : undefined}
                            onEdit={this.UserStore.hasPermission('Permissions.Admin.Warehouses.Update') ? this.onEdit : undefined}
                            onDelete={this.UserStore.hasPermission('Permissions.Admin.Warehouses.Delete') ? this.removeWarehouse : undefined}
                        />
                    </Col>
                </Row>
                <Modal isOpen={this.state.warehouseModalOpen} toggle={this.toggleWarehouseModal} backdrop="static">
                    <ModalHeader toggle={this.toggleWarehouseModal}>
                        Add/Edit Warehouse
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md="6">
                                <FormGroup className="required">
                                    <Label>Name</Label>
                                    <EInput
                                        type="text"
                                        name="name"
                                        required={true}
                                        value={this.state.warehouse.name}
                                        onChange={this.handleChange}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label>Phone</Label>
                                    <EInput
                                        type="text"
                                        name="phone"
                                        data-mask="phone"
                                        value={this.state.warehouse.phone}
                                        onChange={this.handleChange}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label>Address 1</Label>
                                    <EInput
                                        type="text"
                                        name="addr1"
                                        value={this.state.warehouse.addr1}
                                        onChange={this.handleChange}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label>Address 2</Label>
                                    <EInput
                                        type="text"
                                        name="addr2"
                                        value={this.state.warehouse.addr2}
                                        onChange={this.handleChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label>City</Label>
                                    <EInput
                                        type="text"
                                        name="city"
                                        value={this.state.warehouse.city}
                                        onChange={this.handleChange}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label>State</Label>
                                    <EInput
                                        type="text"
                                        name="state"
                                        value={this.state.warehouse.state}
                                        onChange={this.handleChange}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label>Zip</Label>
                                    <EInput
                                        type="text"
                                        name="zip"
                                        value={this.state.warehouse.zip}
                                        onChange={this.handleChange}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.toggleWarehouseModal}>Cancel</Button>
                        <EButton color="primary" onClick={this.handleSave}>Save Warehouse</EButton>
                        <EButton color="primary" onClick={this.addAnother}>Add Another</EButton>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

}

export default AdminWarehouses;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Warehouses/AdminWarehouses.tsx